import { isProdEnvironment } from "@/lib/stageUtils";

/**
 * BRE-4422: single source of truth for whether the soft-refresh
 * <VersionUpdateToast> is active (vs. the legacy reload-then-banner).
 *
 * Previously this was gated behind the `version-update-soft-refresh-enabled`
 * PostHog flag. That flag has been removed: the soft-refresh path is now
 * enabled for ALL non-prod environments (staging, dev, pr-* previews) so it
 * can be exercised by every user there, and stays OFF in prod — where the
 * server-action encryption key is intentionally not yet pinned, so the legacy
 * reload remains the correct behavior until prod is provisioned.
 *
 * Read synchronously from both React (<StaleDeploymentSurface>) and non-React
 * code (`handleStaleDeploymentError` in get-query-client.ts). `isProdEnvironment`
 * resolves from the build-inlined NEXT_PUBLIC_SST_STAGE, so it's stable on
 * client and server with no async/race.
 *
 * To enable in prod later: pin the prod NextServerActionsEncryptionKey secret,
 * then drop the `!isProdEnvironment()` gate here (always-on) or add the explicit
 * prod opt-in.
 */
export function isSoftRefreshEnabled(): boolean {
  return !isProdEnvironment();
}
